<template>
<div>
  <div class='header'>
    <div v-for='f in headerFields' :style='calcWidth(f)'>
      {{f.display}}
    </div>
  </div>
  <div class='body'>
    <div class='row' v-for='r in rows' :key='r.id' @click='rowSelected(r)'>
      <div v-for='f in headerFields' :style='calcWidth(f)'>
        {{r[f.field]}}
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  props: {
    rows: {
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    rowSelected(row) {
      this.$emit("rowselected", row);
    },
    calcWidth(field) {
      var result = {};
      if (field.maxWidth) {
        result["max-width"] = field.maxWidth + "px";
      }
      if (field.width) {
        result["width"] = field.width + "px";
      }
      return result;
    }
  },
  computed: {
    headerFields() {
      return {
        id: {
          sortable: false,
          display: "ID",
          field: "id",
          maxWidth: 100
        },
        firstName: {
          sortable: false,
          display: "First Name",
          field: "firstName"
        },
        lastName: { sortable: false, display: "Last Name", field: "lastName" },
        email: { sortable: false, display: "Email", field: "lastName" }
      };
    }
  }
};
</script>

<style scoped lang='scss'>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  padding: 12px 24px;
  border-bottom: 2px solid $gray-4;
  > div {
    flex: 1;
  }
}
.row {
  display: flex;
  font-weight: 400;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  padding: 6px 24px;
  border-bottom: 1px dotted $gray-4;
  > div {
    flex: 1;
  }
}
.row:hover {
  background: $gray-2;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/aGrid.vue